import { Button, Form, Select } from 'antd';
import { useGetStationList } from 'features/master/use-cases/get-station';
import { UserFormValues } from 'features/users/components/users-filter-form';
import { useCreateStationMapping } from 'features/users/use-cases/create-station';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

export const AddsatationuserMappingModal = ({
    onClose,
    getUserMapping
}: {
    onClose: () => void;
    getUserMapping:any
}) => {
    const formName = 'add-user-form';
    const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
    const [form] = Form.useForm<UserFormValues>();
    const { isLoading, mutate } = useCreateStationMapping();
    const { data } = useGetStationList('' as any);
    const { id } = useParams(); // <-- this will be your UUID
    const [selectedStations, setSelectedStations] = useState<number[]>([]);
    const handleClose = () => {
        onClose();
        form.resetFields();
    };
    const handleUserUpdate = () => {
        const payload: any = {
            userId: id,
            stationIds: selectedStations.map((stationId) => ({
                stationId,
                roleId: null, // default roleId if not found
            })),
        };
        mutate(payload, {
            onSuccess: () => {
                handleClose()
                getUserMapping()
            }
        });
        setSelectedStations([]); // ✅ clear selectionn
    };

    return (
        <>
            <div className={'popup'}>
                <div className='modal_head'>
                    <button onClick={handleClose} className='close-btn'>
                        &times;
                    </button>
                </div>
                <div className='modal_body'>
                    <Form<UserFormValues>
                        id={formName}
                        name={formName}
                        form={form}
                        layout='vertical'
                        onFinish={handleUserUpdate}
                        autoComplete='new-password'
                        onFinishFailed={() => {
                            setValidateTrigger(['onChange']);
                        }}
                        validateTrigger={validateTrigger}
                        disabled={isLoading}
                    >
                        <Form.Item label="Station Mapping">
                            <Select
                                mode='multiple'
                                style={{ width: '100%' }}
                                placeholder='Select Station(s)'
                                 value={selectedStations} // <-- add this
                                options={data?.rc?.map((item) => ({
                                    label: item?.title,
                                    value: item?.id,
                                }))}
                                onChange={(value) => setSelectedStations(value)}
                            />
                        </Form.Item>
                        <div className='form-button'>
                            <Button type='primary' htmlType='submit' className='btn'>
                                Save
                            </Button>
                        </div>
                    </Form>
                </div>
            </div>
        </>
    );
};
